/**
 * Limsa Variant-Aware Gallery — 2026-04-19
 * Varyant (renk) seçildiğinde product gallery'yi reorder eder:
 *   → Seçili rengin tüm variant'larına bağlı media'lar başa gelir
 *   → Diğer media'lar sonda kalır (orijinal sıra korunur)
 *
 * Veri kaynağı: window._limsaProduct (main-product.liquid inject eder)
 * Color option detection: option name "color/colour/renk" içeriyorsa
 *
 * Hedef DOM'lar:
 *   .product__media-wrapper .swiper-wrapper
 *   media-gallery .swiper-wrapper
 *   .product__media-list
 */
(function () {
  'use strict';

  function log(msg, data) {
    try { console.debug('[limsa-variant-gallery]', msg, data || ''); } catch (e) {}
  }

  function getProduct() {
    if (window._limsaProduct && window._limsaProduct.variants) return window._limsaProduct;
    /* Fallback: script[type="application/json"] with product */
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && data.variants && data.media) return data;
      } catch (e) {}
    }
    return null;
  }

  function findColorOptionIndex(product) {
    if (!product.options) return -1;
    var names = Array.isArray(product.options) ? product.options : [];
    /* If options is array of strings (names only) */
    if (typeof names[0] === 'string') {
      for (var i = 0; i < names.length; i++) {
        if (/^(color|colour|renk|farbe)$/i.test(names[i])) return i;
      }
    } else if (product.options_with_values) {
      /* array of {name, values} */
      for (var j = 0; j < product.options_with_values.length; j++) {
        if (/^(color|colour|renk|farbe)$/i.test(product.options_with_values[j].name)) return j;
      }
    }
    return -1;
  }

  function getSelectedVariantId() {
    /* Shopify product form variant id input */
    var sel = document.querySelector(
      'form[action*="/cart/add"] [name="id"], variant-radios [name="id"], variant-selects [name="id"]'
    );
    if (!sel) return null;
    var v = sel.value;
    if (!v || isNaN(parseInt(v))) return null;
    return parseInt(v);
  }

  function getMatchingMediaIds(product, selectedVariantId) {
    var colorIdx = findColorOptionIndex(product);
    if (colorIdx === -1) return [];
    var variant = product.variants.find(function (v) { return v.id === selectedVariantId; });
    if (!variant) return [];
    var colorValue = variant['option' + (colorIdx + 1)];
    if (!colorValue) return [];

    var mediaIds = [];
    var variants = product.variants || [];
    var media = product.media || [];

    /* 1) featured_media per matching variant */
    for (var vi = 0; vi < variants.length; vi++) {
      var v = variants[vi];
      if (v['option' + (colorIdx + 1)] !== colorValue) continue;
      var mid = null;
      if (v.featured_media && v.featured_media.id) mid = v.featured_media.id;
      else if (v.featured_media_id) mid = v.featured_media_id;
      if (mid && mediaIds.indexOf(mid) === -1) mediaIds.push(mid);
    }

    /* 2) Position grouping: her rengin featured position'u grup başlangıcı */
    var colorPosList = [];
    for (var vi2 = 0; vi2 < variants.length; vi2++) {
      var v2 = variants[vi2];
      if (!v2.featured_media) continue;
      var c2 = v2['option' + (colorIdx + 1)];
      if (!c2) continue;
      var found = false;
      for (var cpi = 0; cpi < colorPosList.length; cpi++) {
        if (colorPosList[cpi].color === c2) { found = true; break; }
      }
      if (!found) colorPosList.push({ color: c2, position: v2.featured_media.position });
    }
    /* Sort by position ascending */
    colorPosList.sort(function (a, b) { return a.position - b.position; });

    /* Find current color's index */
    var curIdx = -1;
    for (var ci = 0; ci < colorPosList.length; ci++) {
      if (colorPosList[ci].color === colorValue) { curIdx = ci; break; }
    }

    if (curIdx !== -1) {
      var startPos = colorPosList[curIdx].position;
      var endPos;
      if (curIdx < colorPosList.length - 1) {
        endPos = colorPosList[curIdx + 1].position - 1;
      } else {
        var maxPos = 0;
        for (var mi = 0; mi < media.length; mi++) {
          if (media[mi].position > maxPos) maxPos = media[mi].position;
        }
        endPos = maxPos;
      }
      if (endPos >= startPos) {
        for (var mi2 = 0; mi2 < media.length; mi2++) {
          var m = media[mi2];
          if (m.position >= startPos && m.position <= endPos) {
            if (mediaIds.indexOf(m.id) === -1) mediaIds.push(m.id);
          }
        }
      }
    }

    /* Debug — window._LIMSA_DEBUG inspect için */
    try {
      window._LIMSA_DEBUG = {
        color: colorValue,
        colorIdx: colorIdx,
        colorPosList: colorPosList,
        curIdx: curIdx,
        mediaIds: mediaIds,
        mediaCount: mediaIds.length
      };
    } catch (e) {}

    /* URL-based match KALDIRILDI (v8 2026-04-19):
       URL'de substring match false positive veriyordu
       (örn "laYERED-ruffled" içinde "red" substring → tüm URL'ler Red match).
       Word boundary check eklemek çok karmaşık (her dil + rakam kombinasyonları).
       Position grouping tek başına yeterli: admin renkleri grup grup upload ettiyse
       (ki standart yaklaşım bu) her rengin featured_media.position'u grup başlangıcı.
       Alt-text match de generic template nedeniyle false positive veriyordu (kaldırılmıştı). */
    return mediaIds;
  }

  function reorderGallery() {
    var product = getProduct();
    if (!product) { log('no product data'); return; }
    var variantId = getSelectedVariantId();
    if (!variantId) { log('no selected variant'); return; }
    var matching = getMatchingMediaIds(product, variantId);
    if (matching.length === 0) { log('no matching media for variant', variantId); return; }

    /* Possible gallery container selectors — LİMSA GERÇEK DOM: .product__media-list */
    var selectors = [
      /* Ana gallery (büyük portre) */
      '.product__media-list',
      'media-gallery .product__media-list',
      'media-gallery ul',
      'slider-component ul.product__media-list',
      /* Thumbnail slider (alttaki küçük şerit) — <li> data-media-id YOK, içindeki <button> taşıyor */
      'ul.thumbnail-list',
      '.thumbnail-list',
      '[id^="Slider-Thumbnails-"]',
      '.product-thumbs-wrap ul',
      '.thumbnail-slider ul',
      /* Backup patterns */
      '.product__media-wrapper .swiper-wrapper',
      'media-gallery .swiper-wrapper',
      '.product-single__media-wrapper',
      '.product__media-gallery .swiper-wrapper',
      '.slider-mobile-gutter.swiper-wrapper',
      '.product__media-wrapper ul',
      'media-gallery ol'
    ];

    var processedWrappers = 0;
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (wrapper) {
        var children = Array.prototype.slice.call(wrapper.children);
        if (children.length < 2) return;

        /* Current order check — Shopify native DOM'u karıştırmış olabilir, yeniden reorder gerek
           İlk N child'ın ID'si matching array'e uyuyor mu? */
        function getId(el){
          var s = el.getAttribute('data-media-id') || el.getAttribute('data-target');
          if (!s) { var inner = el.querySelector('[data-media-id], [data-target]'); if (inner) s = inner.getAttribute('data-media-id') || inner.getAttribute('data-target'); }
          if (!s) return null;
          var d = parseInt(s);
          if (!isNaN(d) && String(d) === s) return d;
          var p = s.split('-').pop(); return parseInt(p);
        }
        var currentFirstIds = children.slice(0, matching.length).map(getId);
        var alreadyOrdered = currentFirstIds.length === matching.length &&
                             matching.every(function(id, idx){ return currentFirstIds[idx] === id; });
        if (alreadyOrdered) return; /* gerçekten aynı sıra — skip */

        var match = [];
        var rest = [];
        children.forEach(function (el) {
          /* Media identifier source priority:
             1. data-media-id (ana gallery <li>)
             2. data-target (thumbnail slider <li>, value = "template--...id")
             3. child element's data-media-id */
          var midStr = el.getAttribute('data-media-id') || el.getAttribute('data-target');
          if (!midStr) {
            var inner = el.querySelector('[data-media-id], [data-target]');
            if (inner) {
              midStr = inner.getAttribute('data-media-id') || inner.getAttribute('data-target');
            }
          }
          if (!midStr) { rest.push(el); return; }

          /* data-media-id formatları:
             - "43041740259623" (düz sayı)
             - "template--26397029302567__main-43041740259623" (section-prefixed)
             Son segment genelde asıl media id */
          var mid = null;
          var directParse = parseInt(midStr);
          if (!isNaN(directParse) && String(directParse) === midStr) {
            mid = directParse;
          } else {
            var parts = midStr.split('-');
            var last = parts[parts.length - 1];
            var parsed = parseInt(last);
            if (!isNaN(parsed)) mid = parsed;
          }

          if (mid && matching.indexOf(mid) !== -1) {
            match.push(el);
          } else {
            rest.push(el);
          }
        });

        if (match.length === 0) return;

        /* Reorder — appendChild moves existing node */
        match.concat(rest).forEach(function (el) { wrapper.appendChild(el); });
        wrapper.dataset.limsaReordered = JSON.stringify(matching);
        processedWrappers++;

        /* Swiper varsa update et */
        setTimeout(function () {
          try {
            if (wrapper.closest('.swiper') && wrapper.closest('.swiper').swiper) {
              wrapper.closest('.swiper').swiper.update();
              wrapper.closest('.swiper').swiper.slideTo(0, 400);
            }
          } catch (e) {}
        }, 40);
      });
    });

    log('reordered ' + processedWrappers + ' gallery wrappers with ' + matching.length + ' matching media');
  }

  function attachListeners() {
    /* Variant form change — Shopify native reorder sonrası için MULTIPLE delay retry */
    function reorderMulti() {
      [80, 300, 700, 1200, 1800, 2500].forEach(function(d){
        setTimeout(function(){ reorderGallery(); applyFlexOrder(); }, d);
      });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (
        t.name === 'id' ||
        (t.name && /option|color|renk/i.test(t.name)) ||
        t.closest('variant-radios, variant-selects, .product-form__input, .product-variant-id')
      ) {
        reorderMulti();
      }
    });
    /* Click events on color swatches (some themes don't fire change) */
    document.addEventListener('click', function (e) {
      if (
        e.target.closest('.color-swatch, .swatch-variant-color, [data-swatch], label[for*="color"], label[for*="renk"], [type="radio"], select option')
      ) {
        setTimeout(reorderGallery, 120);
      }
    });
    /* Shopify custom events (some themes fire these) */
    document.addEventListener('on:variant:change', function () { setTimeout(reorderGallery, 60); });
    document.addEventListener('variant:change', function () { setTimeout(reorderGallery, 60); });
  }

  /* VALUE POLLING — en güvenilir yöntem.
     Variant form [name="id"] hidden input'un value'su her variant değişiminde set edilir.
     Event bypass edilse bile bu value değişir → polling ile yakala. */
  function startValuePolling() {
    var idInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"], variant-radios [name="id"], variant-selects [name="id"], .product-variant-id'
    );
    if (!idInput) return;
    var lastValue = idInput.value;
    setInterval(function () {
      var nowValue = idInput.value;
      if (nowValue !== lastValue) {
        lastValue = nowValue;
        log('variant id changed → ' + nowValue);
        reorderGallery();
      }
    }, 250);
  }

  /* MutationObserver — Shopify native DOM manipulation'larını yakala */
  function startMutationObserver() {
    var targets = document.querySelectorAll('.product__media-list, ul.thumbnail-list, [id^="Slider-Gallery-"], [id^="Slider-Thumbnails-"]');
    if (!targets.length) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        reorderGallery();
      }, 120);
    });
    targets.forEach(function (t) {
      observer.observe(t, { childList: true, subtree: false, attributes: false });
    });
  }

  /* Periodic reorder — 600ms'de bir kontrol et, Shopify native bozduysa onar
     (idempotent: alreadyOrdered check varsa skip eder) */
  function startPeriodicReorder() {
    setInterval(function () {
      reorderGallery();
    }, 600);
  }

  /* VISIBILITY FILTER — class-based (Shopify native display:none bypass).
     Shopify slider-component active olmayan slide'lara display:none ekliyor.
     Biz `.limsa-show-all` class'ı ile Shopify'ın display:none'ını ezer (CSS injection),
     sonra non-matching'lere kendi `.limsa-v-hidden` class'ımızı ekleriz. */

  /* CSS inject — bir kez.
     v10 fix: main gallery için Shopify'ın is-active logic'ine UYGUN kalırız,
     sadece thumbnail-list için variant filter yaparız. Ana medyada tek image görünür. */
  function ensureStyleInjected() {
    if (document.getElementById('limsa-variant-gallery-style')) return;
    var style = document.createElement('style');
    style.id = 'limsa-variant-gallery-style';
    style.textContent =
      /* Thumbnail list için: sadece variant'a ait olanları göster */
      '.limsa-variant-gallery-active ul.thumbnail-list .thumbnail-list__item.limsa-v-hidden {' +
      '  display: none !important;' +
      '}' +
      /* Main gallery: Shopify default .is-active logic kalsın — HİÇBİR override yok.
         Sadece non-active item'ları inline style ile gizle (double protection) */
      '.limsa-variant-gallery-active .product__media-item.limsa-v-hidden {' +
      '  display: none !important;' +
      '}';
    document.head.appendChild(style);
    document.documentElement.classList.add('limsa-variant-gallery-active');
  }

  function applyVisibilityFilter() {
    ensureStyleInjected();
    var product = getProduct();
    if (!product) return;
    var vid = getSelectedVariantId();
    if (!vid) return;
    var matching = getMatchingMediaIds(product, vid);
    if (!matching.length) return;

    function getId(el) {
      var s = el.getAttribute('data-media-id') || el.getAttribute('data-target');
      if (!s) { var inner = el.querySelector('[data-media-id], [data-target]'); if (inner) s = inner.getAttribute('data-media-id') || inner.getAttribute('data-target'); }
      if (!s) return null;
      var d = parseInt(s);
      if (!isNaN(d) && String(d) === s) return d;
      return parseInt(s.split('-').pop());
    }

    /* v11 fix: Shopify'ın native variant-featured_image logic ana galeriyi otomatik
       değiştiriyor (variant.featured_media.id → is-active swap). Biz ana galerie
       DOKUNMUYORUZ — Shopify kendi halletsin.
       Sadece thumbnail-list'i variant'a göre filter yaparız. */

    /* THUMBNAIL LIST: matching'leri göster, non-matching'leri hide. */
    document.querySelectorAll('ul.thumbnail-list').forEach(function (wrapper) {
      Array.prototype.slice.call(wrapper.children).forEach(function (el) {
        var mid = getId(el);
        if (mid && matching.indexOf(mid) !== -1) {
          el.classList.remove('limsa-v-hidden');
          el.style.removeProperty('display');
          el.style.order = matching.indexOf(mid);
        } else {
          el.classList.add('limsa-v-hidden');
          el.style.order = '';
        }
      });
    });

    /* Debug attach */
    try { window._LIMSA_DEBUG_FILTER = { vid: vid, matching: matching, firstMatchId: matching[0] }; } catch (e) {}
  }

  /* v11: thumbnail click handler KALDIRILDI — Shopify'ın native thumbnail-list
     component'i zaten clicks'i handle edip ana galeriye is-active atıyor.
     Bizim ek logic Shopify'ın native behavior'ı ile çatışıyordu (Daila Bone bug). */
  function attachThumbnailClickHandler() { /* no-op, delegated to Shopify native */ }

  /* Alias legacy call */
  var applyFlexOrder = applyVisibilityFilter;

  function init() {
    attachListeners();
    startValuePolling();
    attachThumbnailClickHandler();
    /* Initial run */
    setTimeout(function(){ reorderGallery(); applyFlexOrder(); }, 400);
    setTimeout(function(){ reorderGallery(); applyFlexOrder(); }, 800);
    setTimeout(function(){ reorderGallery(); applyFlexOrder(); }, 1500);
    setTimeout(function(){ reorderGallery(); applyFlexOrder(); }, 2500);
    setTimeout(function(){ reorderGallery(); applyFlexOrder(); }, 3500);
    setTimeout(startMutationObserver, 1000);
    setTimeout(startPeriodicReorder, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
